import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import Logo from '../assets/images/Logo.png'
import { Icon } from '@iconify/react'
/**
 * `AuthLayout` is a layout component that wraps authentication-related routes.
 * It provides a structured UI with a sidebar, logo, and navigation controls.
 *
 * - If the user is on the `/auth/sign-up` page, only the child routes (Outlet) are rendered.
 * - For other auth routes, it displays a structured UI with an optional close button.
 *
 * @returns {JSX.Element} The authentication layout component.
 */
const AuthLayout: React.FC = () => {
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <>
            {!(location?.pathname === '/auth/sign-up') ? (
                <div className='bg-cyan w-full h-full fixed sm:p-6'>
                    <div className='w-full h-full bg-white overflow-hidden sm:rounded-3xl'>
                        <div className='flex h-full'>
                            <div className='w-1/2 sm:block hidden bg'></div>
                            <div className='sm:w-1/2 w-full'>
                                <div className={`${!(location.pathname === '/auth/sign-in') && 'p-4 flex justify-end items-center'}`}>
                                    {!(location.pathname === '/auth/sign-in') && (
                                        <Icon
                                            icon='radix-icons:cross-2'
                                            className='text-red justify-end items-end cursor-pointer'
                                            width='24'
                                            height='24'
                                            onClick={() => {
                                                navigate('/auth/sign-in')
                                            }}
                                        />
                                    )}
                                </div>
                                <div className='container mx-auto w-full h-full p-6 md:p-0'>
                                    <div className='flex flex-col items-center justify-center mx-auto h-full'>
                                        <div className='w-full lg:max-w-md sm:max-w-xs overflow-y-auto pt-5 pb-12'>
                                            <div className='space-y-4 text-center xxl:pb-0'>
                                                <div className='flex flex-col justify-center items-center'>
                                                    <img className='w-1/4' src={Logo} alt='logo' />
                                                </div>
                                                <Outlet />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <>
                    <Outlet />
                </>
            )}
        </>
    )
}

export default AuthLayout
